import { type PropertyValue } from 'api/clients/PropertyClient'
import { isString } from 'lodash'
import { Text as BlazeText } from 'blaze-ui/Text/Text'

interface Props {
  propertyValue?: PropertyValue
}

const Text = ({ propertyValue }: Props) => {
  if (!isString(propertyValue?.value)) return <></>

  return <BlazeText variant="secondary">{propertyValue?.value}</BlazeText>
}

export default Text
